import { AfterContentInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { CheckableSettings, FilterExpandSettings } from '@progress/kendo-angular-treeview';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';
import { LocationDropDownModel } from 'src/app/shared/models/locations-drop-down-list.model';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { State } from 'src/app/state/app.state';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';

@Component({
    selector: 'location-selector-tree-view',
    templateUrl: './location-selector-tree-view.component.html',
    styleUrls: ['./location-selector-tree-view.component.scss']
})
export class LocationSelectorTreeViewComponent implements AfterContentInit {
    // get root locations ids as input
    @Input() expandedKeys: number[] = [];
    // get checked components Tree view unique id0
    @Input() selectedLocationId: number = 0;

    @Input() locations: LocationDropDownModel[] = [];
    @Input() dispatchStateEvent: boolean = true;

    @Output() closeEvent: EventEmitter<LocationSelectorInfo> = new EventEmitter<LocationSelectorInfo>();
    @Output() onChange: EventEmitter<any> = new EventEmitter();

    public locationSelector: LocationSelectorInfo = {
        id: 0,
        locationName: '',
        locationCode: '',
        utcoffsetInMinutes: 0,
        locationTypeId: 0,
        timezoneId: '',
        timeZoneName: '',
        dropDownDisabled: false,
        lastLocationAutoWraupTime: ''
    };

    // currently checked Tree view unique id
    public checkedKeys: number[] = [];
    public checkAll: boolean = true;

    // Checking component
    public key = 'locationId';

    constructor(private locationService: LocationService, private store: Store<State>, private translationLoaderFacade: TranslationLoaderFacade) { }
    
    public ngOnInit(): void {      
    }
    ngAfterContentInit() {
        this.addExpandListItem(this.locations);
    }

    showClick(dataItem: any) {
        this.locationSelector = {
            id: dataItem?.locationId,
            locationName: dataItem?.locationName,
            locationCode: dataItem?.locationCode,
            locationTypeId: dataItem?.locationTypeId,
            utcoffsetInMinutes: dataItem?.utcoffsetInMinutes,
            timezoneId: dataItem?.timeZoneId,
            timeZoneName: dataItem?.timeZoneName,
            dropDownDisabled: false,
            lastLocationAutoWraupTime: dataItem?.lastLocationAutoWraupTime
        };

        if (this.dispatchStateEvent == true) {

            this.store.dispatch(CoreActions.updateLocationSelectorInfo({
                payload:
                    { locationSelectorInfo: this.locationSelector }
            }));
            this.store.dispatch(CoreActions.updateACLocationSelectorInfo({
                payload: {
                    acLocationCode: this.locationSelector.locationCode
                }
            }));
        }

        this.closeEvent.emit(this.locationSelector);
    }


    // check item has children
    public hasChildren(item: LocationDropDownModel) {
        return item.hasChild;
    }

    // fetch childrend data
    public fetchChildren = (item: any) => this.locationService.getHierarchyChildLocations(item.locationId);

    // checking settings
    public get checkableSettings(): CheckableSettings {
        return {
            checkChildren: true,
            checkParents: true,
            enabled: true,
            mode: 'multiple',
            checkOnClick: true,
        };
    }

    public filterExpandSettings: FilterExpandSettings = {
        maxAutoExpandResults: 4,
        expandedOnClear: "unchanged"
    };

    private addExpandListItem(treeItem?: LocationDropDownModel[]) {
        if (!treeItem) return;

        treeItem.forEach(item => {
            if (item.hasChild) {
                this.addExpandListItem(item.items)
            }
        });
    }
}
